import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';
import { Button, Row, Col, FormText, Form, FormGroup, Label, Input } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  TextField,
  Select,
  MenuItem,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled, createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { getCommoditiesByBankId } from 'app/entities/commodity/commodity.reducer';
import { getEntities as getCurrencies } from 'app/entities/currency-index/currency-index.reducer';
import { getEntities as getCurrencyRates } from 'app/entities/currency-rates/currency-rates.reducer';
import { getEntity as getBranch } from 'app/entities/branch/branch.reducer';
import { createPONumber } from 'app/entities/purchase-order/purchase-order.reducer';
import { getAllEntities as getNotificationTemplates } from 'app/entities/notification-template/notification-template.reducer';
import {
  getEntitiesByUserId as getNotificationByUserId,
  createEntity as createNotification,
  sendEmailQuotationDetail,
} from 'app/entities/notification-record/notification-record.reducer';
import { getEntityWithoutPending, updateEntity, updateEntity as updateQuotation } from './quotation.reducer';
import { countryList } from 'app/entities/bank/country';
import { Storage } from 'react-jhipster';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import './quotation-update.css';
import { AUTHORITIES } from 'app/config/constants';
import {
  getBranchManagerUser,
  getUserByLogin,
  getUsersAsAlmoskhAdminAndStaff,
} from 'app/modules/administration/user-management/user-management.reducer';
import PhoneInput from 'react-phone-input-2';
import moment from 'moment/moment';
import 'moment-timezone';
import { getEntity as getComexSetting } from 'app/entities/comex-settings/comex-settings.reducer';
import ErrorDialog from 'app/shared/error/error-dialog';
import {ICommodity} from "app/shared/model/commodity.model";
import {createEntity, getEntityByQuotationId, updateEntity as updateIban} from "app/entities/quotation/iban-reducer";
import IbanDisplayButton from "app/entities/quotation/bought/components/iban-display-button";
import {AddIbanDialog} from "app/entities/quotation/bought/components/add-iban-dialog";
import SlotProcessingDialog from "app/entities/quotation/bought/components/slot-processing-dialog";
import {IIban} from "app/shared/model/iban.model";
import {TransactionRefNoSection} from "app/entities/quotation/components/transaction-reference-section";
import {QuotationPrint} from "app/entities/quotation/bought/components/quotation-print";
import {QuotationPrint as BoubyanQuotationPrint} from "app/entities/quotation/client-docs/boubyan-bank/quotation/quotation-print";
import {IUser} from "app/shared/model/user.model";
import {isBoubyanQuotation, resolveLumpSumFeeAmount, isCommissionModeForBank, resolveCurrencyIdForFiltering} from "app/shared/util/quotation-utils";
import {getFeeListByBankIdAndCommodityType} from "app/entities/comex-bank-fee/comex-bank-fee.reducer";

export const QuotationPurchase = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const quotationEntity = useAppSelector(state => state.quotation.entity);
  const updating = useAppSelector(state => state.quotation.updating);
  const updateSuccess = useAppSelector(state => state.quotation.updateSuccess);
  // const date = `${formatTwoDigits(tempDate.getDate())}/${formatTwoDigits(tempDate.getMonth() + 1)}/${tempDate.getFullYear()}`;
  // const date = `${tempDate.getFullYear()}/${formatTwoDigits(tempDate.getMonth() + 1)}/${formatTwoDigits(tempDate.getDate())}`;
  const dateAndTime = moment(quotationEntity?.createdDate).format('yyyy/MM/DD HH:mm:ss');
  const date = moment(quotationEntity?.createdDate).format('yyyy/MM/DD');

  const componentRef = useRef();

  const specBranch = useAppSelector(state => state.branch.entity);
  const commodities = useAppSelector(state => state.commodity.entities);
  const currencyRateList = useAppSelector(state => state.currencyRates.entities);
  const account = useAppSelector(state => state.authentication.account);
  const notificationtemplate = useAppSelector(state => state.notificationTemplate.entities);

  const bankStaff = useAppSelector(state => state.userManagement.bankStaff);
  const [loading, setLoading] = useState(true);
  const [itemDescription, setItemDescription] = useState('');
  const [itemDescriptionInArabic, setItemDescriptionInArabic] = useState('');
  const [itemPrice, setItemPrice] = useState(0);
  const [itemName, setItemName] = useState('');
  const [itemQuantity, setItemQuantity] = useState(0);
  const [amountV, setAmount] = useState(1);
  const [currencyName, setCurrencyName] = useState('');
  const [cusIc, setCusIc] = useState('');
  const [cusName, setCusName] = useState('');
  const [cusNameAr, setCusNameAr] = useState('');
  const [cusNationality, setNationality] = useState('');
  const [phone, setPhone] = useState('');
  const [cusEmail, setCusEmail] = useState('');
  const [isAmend, setIsAmend] = useState(false);
  const [isApprovePurchase, setIsApprovePurchase] = useState(false);
  const [slotAlreadyProcessing, setSlotAlreadyProcessing] = useState<'purchase' | null>(null);
  const [isDone, setIsDone] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const comexSettingsEntity = useAppSelector(state => state.comexSettings.entity);
  const [operationTime, setOperationTime] = useState(true);
  const [openEmailDialog, setOpenEmailDialog] = React.useState(false);
  const [clickPurchase, setClickPurchase] = React.useState(false);
  const [localStart, setLocalStart] = React.useState<any>(new Date('2018-01-01T19:30:00.000Z'));
  const [localEnd, setLocalEnd] = React.useState<any>(new Date('2018-01-01T17:29:00.000Z'));
  const selectedNationality = countryList?.find(c => c?.Desc_en === cusNationality);
  const [from, setFrom] = useState<Date | null>(moment().subtract(30, 'day').toDate());
  const [to, setTo] = useState<Date | null>(new Date());
  const [isDefaultCurrency, setIsDefaultCurrency] = useState(false);
  const bankFeeList = useAppSelector(state => state.comexBankFee.entities);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      fontSize: '0.55rem',
      fontWeight: 'bold',
      textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
      overflow: 'hidden',
      textOverflow: 'clip',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: '0.55rem',
      textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
      overflow: 'hidden',
      textOverflow: 'clip',
      wordWrap: 'break-word',
    },
  }));

  const StyledTable = styled(Table)(({ theme }) => ({
    '&.MuiTable-root': {
      tableLayout: 'fixed',
      width: '100%',
    },
  }));

  useEffect(() => {
    Promise.all([
      dispatch(getEntityWithoutPending(props.match.params.id)),
      dispatch(getCurrencies({})),
      dispatch(getCurrencyRates({})),
      dispatch(getNotificationTemplates({})),
      dispatch(getComexSetting(1)),
    ]);
  }, []);

  useEffect(() => {
    quotationEntity?.createdBy !== undefined && dispatch(getUserByLogin(quotationEntity?.createdBy));
    dispatch(getCommoditiesByBankId(quotationEntity?.branch?.bank?.id));
  }, [quotationEntity]);

  useEffect(() => {
    setItemName(quotationEntity?.commodity?.name);
    setAmount(quotationEntity?.amount);
    setItemDescription(quotationEntity?.commodity?.description);
    setItemPrice(quotationEntity?.commodity?.price);
    setItemQuantity(parseFloat(quotationEntity?.commodityQuantity?.toFixed(4)));
    setCusName(quotationEntity?.customer?.name);
    setCusNameAr(quotationEntity?.customer?.nameArabic);
    setCusIc(quotationEntity?.customer?.ic);
    setNationality(quotationEntity?.customer?.nationality);
    setPhone(quotationEntity?.customer?.tel);
    setCusEmail(quotationEntity?.customer?.email);
    setCurrencyName(quotationEntity?.currencyIndex?.name);
    const feeCurrency = quotationEntity?.bank?.feeCurrency;
    setIsDefaultCurrency(feeCurrency ? feeCurrency.toLowerCase() === 'bank default currency'.toLowerCase() : false);
    localStorage.setItem('print', 'false');
  }, [quotationEntity]);

  useEffect(() => {
    if (quotationEntity?.bank?.id && quotationEntity?.commodity) {
      const commodityType = quotationEntity.commodity.ownership === 'Local' ? 'Local' : 'International';
      dispatch(getFeeListByBankIdAndCommodityType({ bankId: quotationEntity.bank.id, commodityType }));
    }
  }, [quotationEntity?.bank?.id, quotationEntity?.commodity?.ownership]);

  // Display-only override: show the real configured Lump Sum fee amount instead of the
  // backend's rounded value already persisted on quotationEntity.
  const isLocal = quotationEntity?.commodity?.ownership === 'Local';
  const isCommissionMode = isCommissionModeForBank(isLocal, quotationEntity?.bank);
  const currencyIdForFiltering = resolveCurrencyIdForFiltering(isDefaultCurrency, quotationEntity?.bank?.currencyId, quotationEntity?.currencyIndexId);

  const displayTransactionFee = useMemo(
    () => (isCommissionMode ? null : resolveLumpSumFeeAmount(bankFeeList, quotationEntity?.amount, currencyIdForFiltering)),
    [bankFeeList, quotationEntity?.amount, currencyIdForFiltering, isCommissionMode]
  );
  const displayFeeInQuotationCurrency = useMemo(() => {
    if (isCommissionMode) return null;
    const quotationCurrencyFilterId = resolveCurrencyIdForFiltering(!isDefaultCurrency, currencyIdForFiltering, quotationEntity?.currencyIndexId);
    return resolveLumpSumFeeAmount(bankFeeList, quotationEntity?.amount, quotationCurrencyFilterId);
  }, [bankFeeList, quotationEntity?.amount, isDefaultCurrency, quotationEntity?.currencyIndexId, currencyIdForFiltering, isCommissionMode]);

  const FRIDAY_PRAYER_START_TIME = '13:15:00';
  const FRIDAY_PRAYER_END_TIME = '13:45:00';
  const currDate = new Date();

  const userLocalStart = moment.tz(FRIDAY_PRAYER_START_TIME, 'HH:mm:ss', 'Asia/Kuala_Lumpur').local().format('hh:mm A');
  const userLocalEnd = moment.tz(FRIDAY_PRAYER_END_TIME, 'HH:mm:ss', 'Asia/Kuala_Lumpur').local().format('hh:mm A');

  const isFriday = currDate.getDay() === 5;

  const isDuringFridayPrayer = currentTime => {
    return currentTime >= FRIDAY_PRAYER_START_TIME && currentTime <= FRIDAY_PRAYER_END_TIME;
  };

  const getCurrentTime = () => {
    return moment().tz('Asia/Kuala_Lumpur').format('HH:mm:ss');
  };

  const checkLocalCommodity = (commodity: ICommodity | undefined) => {
    return commodity?.isActive === true && commodity?.ownership === 'Local';
  };
  const isLocalCommodity = checkLocalCommodity(quotationEntity?.commodity);

  const isBankStaff = account?.authorities?.includes(AUTHORITIES.BANK_STAFF);
  const isCreatedToday = (createdDate: string | undefined) => {
    return moment(createdDate).format('YYYY/MM/DD') === moment().format('YYYY/MM/DD');
  };

  const checkIfPurchaseLabelDisabled = (createdDate: string | undefined) => {
    const isCreatedTodayVal = isCreatedToday(createdDate);
    return !isBankStaff || updating || (!isLocalCommodity && !isCreatedTodayVal);
  };

  const isPurchaseLabelDisabled = checkIfPurchaseLabelDisabled(quotationEntity?.createdDate);

  const PurchaseLabelMessage = () => {
    if (
      quotationEntity?.bankManagerApproval === null &&
      quotationEntity?.bankCustomerApproval === null &&
      operationTime === true &&
      isBankStaff &&
      !isLocalCommodity &&
      !sameDayWithCreatedDay
    ) {
      return (
        <div className="col-12 col-sm-12 btn-group-direction mb-2">
          <span style={{ color: 'red' }}>
            <Translate contentKey="home.purchaseYesterday'sQuotation" />
          </span>
        </div>
      );
    }
    return null;
  };

  const todayDate = moment().format('yyyy/MM/DD');
  const getQuotationDisclaimer = () => {
    if (isLocalCommodity && quotationEntity?.bank?.quotationValidityDays !== null) {
      const validityEndDate = quotationEntity?.validUntil
        ? moment(quotationEntity.validUntil).format('DD MMMM YYYY')
        : moment(date)
            .add(quotationEntity.bank.quotationValidityDays - 1, 'days')
            .format('DD MMMM YYYY');

      return translate('comexApp.quotation.transactionForms.quotationPrintDisclaimerWithDate', {
        validityEndDate,
      });
    }

    if (date !== todayDate) {
      return translate('comexApp.quotation.transactionForms.quotationPrintDisclaimerWithDate', {
        validityEndDate: moment(date).format('DD MMMM YYYY'),
      });
    }

    return translate('comexApp.quotation.transactionForms.quotationPrintDisclaimer');
  };

  const getMessage = () => {
    const isDuringFridayPrayerTime = isFriday && isDuringFridayPrayer(getCurrentTime());
    if (isLocalCommodity !== undefined && !isLocalCommodity && isDuringFridayPrayerTime) {
      return <Translate contentKey="home.fridayPrayerMessage" interpolate={{ startTime: userLocalStart, endTime: userLocalEnd }} />;
    } else {
      return (
        <Translate
          contentKey="home.operationTime"
          interpolate={{
            startTime: moment(localStart).tz(moment.tz.guess()).format('hh:mm A'),
            endTime: moment(localEnd).tz(moment.tz.guess()).format('hh:mm A'),
          }}
        />
      );
    }
  };

  const hidetotalAmount = true;

  useEffect(() => {
    if (account?.login !== undefined) {
      const userTimeZone = moment.tz.guess();
      const operationStartMalayTime = moment.utc(comexSettingsEntity?.operationStartTime).tz('Asia/Kuala_Lumpur');
      const operationEndMalayTime = moment.utc(comexSettingsEntity?.operationEndTime).tz('Asia/Kuala_Lumpur');
      const operationStartLocalTime = moment(operationStartMalayTime).tz(userTimeZone);
      const operationEndLocalTime = moment(operationEndMalayTime).tz(userTimeZone);
      setLocalStart(operationStartLocalTime.toDate());
      setLocalEnd(operationEndLocalTime.toDate());

      const currentTime = getCurrentTime();
      const duringFridayPrayer = isDuringFridayPrayer(currentTime);

      if (isLocalCommodity !== undefined && !isLocalCommodity && isFriday && duringFridayPrayer) {
        setOperationTime(false);
        return;
      }

      const currentMalayTime = moment().tz('Asia/Kuala_Lumpur');
      const startTime = moment(currentMalayTime).set({
        hour: operationStartMalayTime.hour(),
        minute: operationStartMalayTime.minute(),
      });

      const endTime = moment(currentMalayTime).set({
        hour: operationEndMalayTime.hour(),
        minute: operationEndMalayTime.minute(),
      });

      if (isLocalCommodity) {
        setOperationTime(true);
      } else {
        if (currentMalayTime.isBetween(startTime, endTime, null, '[]')) {
          setOperationTime(true);
        } else {
          setOperationTime(false);
        }
      }
    }
  }, [comexSettingsEntity, quotationEntity]);

  useEffect(() => {
    const selectedItem = commodities.find(element => element?.name === itemName);
    const selectedCurrencyRate = currencyRateList?.find(element => element?.buyFrom?.name === currencyName);
    if (selectedItem) {
      setItemDescription(selectedItem?.description);
      setItemPrice(selectedItem?.price);
    }
    if (selectedCurrencyRate) {
      const newItemQuantity = (amountV * selectedCurrencyRate?.exchangeRate) / selectedItem?.price;
      setItemQuantity(parseFloat(newItemQuantity.toFixed(4)));
    }
  }, [itemName, amountV]);

  // For Add Buyer
  const accountsUser = useAppSelector(state => state.userManagement.accountsUser);
  const [testUser, setTestUser] = useState<IUser[]>([]);

  useEffect(() => {
    dispatch(getUsersAsAlmoskhAdminAndStaff({}));
  }, [dispatch]);

  useEffect(() => {
    if (accountsUser && accountsUser.length > 0) {
      const filtered = accountsUser.filter(user => user.authorities.includes(AUTHORITIES.BUYER_OF_COMMODITIES));
      setTestUser(filtered);
    }
  }, [accountsUser]);

  const commodityBuyerData = testUser?.[0];

  const saveEntity = async values => {
    await dispatch(getEntityWithoutPending(props.match.params.id)).then(async res => {
      localStorage.setItem('showErrorDialog', 'false');
      const quoCreatedDate = moment(res.payload['data'].createdDate).local();
      const today = moment();
      if (
        res.payload['data'].purchaseOrderId === null &&
        res.payload['data'].status === 'Quoted' &&
        res.payload['data'].bankManagerApproval === null &&
        res.payload['data'].bankCustomerApproval === null &&
        ((!isLocalCommodity && quoCreatedDate.isSame(today, 'day')) || isLocalCommodity) &&
        account?.authorities?.includes(AUTHORITIES.BANK_STAFF)
      ) {
        const newPurchaseOrder = await dispatch(createPONumber());
        const branchManagers = await dispatch(getBranchManagerUser(account.branchId));
        const updateQuoEntity = await dispatch(
          updateQuotation({
            ...quotationEntity,
            ...values,
            purchaseOrder: newPurchaseOrder?.payload['data'],
            purchaseOrderId: newPurchaseOrder?.payload['data']?.id,
            status: 'Bought',
            bankManagerApproval: !specBranch?.managerApproval || isLocalCommodity,
            bankCustomerApproval: false,
            approvedBy: !specBranch?.managerApproval === true ? null : null,
            commodityBuyer: isLocalCommodity ? commodityBuyerData : null,
            commodityBuyerId: isLocalCommodity ? commodityBuyerData?.id : null,
          })
        );
        // getting userBranchManager
        if (updateQuoEntity?.payload['response']) {
          if (updateQuoEntity?.payload['response'].data?.status === 500) {
            localStorage.setItem('showErrorDialog', 'true');
            localStorage.setItem('errorMessage', updateQuoEntity?.payload['response'].data?.title);
            return;
          }
        }

        const notifTemplateApproval = notificationtemplate?.filter(temp => temp?.type === 'poApprovalRequested')[0];
        const notificationTemplateValueApproval = {
          id: notifTemplateApproval?.id,
          type: notifTemplateApproval?.type,
          medium: notifTemplateApproval?.medium,
          language: notifTemplateApproval?.language,
          message: notifTemplateApproval?.message,
        };

        if (quotationEntity?.branch?.managerApproval) {
          branchManagers?.payload['data']?.forEach(branchManager => {
            const notificationEntity = {
              message: notifTemplateApproval?.message?.replace('{quotationNo}', updateQuoEntity?.payload['data']?.id),
              status: 'Send',
              customerID: quotationEntity?.customer?.id,
              dismissed: false,
              userID: branchManager?.id,
              quotationId: quotationEntity?.id,
              notificationTemplate: notificationTemplateValueApproval,
            };
            dispatch(createNotification(notificationEntity));
          });
        }
      } else if (
        res.payload['data'].purchaseOrderId !== null &&
        res.payload['data'].status === 'Bought' &&
        res.payload['data'].approvedBy === null &&
        (account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER) || account?.authorities?.includes(AUTHORITIES.PURCHASE_APPROVAL))
      ) {
        const updatedQuotationEntity = {
          ...quotationEntity,
          status: 'Bought',
          bankManagerApproval: true,
          // bankCustomerApproval: false,
          approvedBy: account?.id,
        };

        const notifTemplateApproved = notificationtemplate?.filter(temp => temp?.type === 'poApproved')[0];
        const notificationTemplateValueApproved = {
          id: notifTemplateApproved?.id,
          type: notifTemplateApproved?.type,
          medium: notifTemplateApproved?.medium,
          language: notifTemplateApproved?.language,
          message: notifTemplateApproved?.message,
        };

        // notification approve purchase by branch manager
        const notificationTemplateValue = {
          id: notificationTemplateValueApproved?.id,
          type: notificationTemplateValueApproved?.type,
          medium: notificationTemplateValueApproved?.medium,
          language: notificationTemplateValueApproved?.language,
          message: notificationTemplateValueApproved?.message,
        };
        const notificationEntity = {
          message: notifTemplateApproved?.message?.replace('{quotationNo}', quotationEntity?.id?.toString()),
          status: 'Send',
          customerID: quotationEntity?.customer?.id,
          dismissed: false,
          userID: bankStaff?.id,
          quotationId: quotationEntity?.id,
          notificationTemplate: notificationTemplateValue,
        };

          setIsApprovePurchase(true);
          dispatch(updateEntity(updatedQuotationEntity)).then(updateQuoEntity => {
            if ((updateQuoEntity as any)?.error?.response?.status === 409) {
              setIsApprovePurchase(false);
              setSlotAlreadyProcessing('purchase');
              return;
            }
            if (updateQuoEntity?.payload["response"]) {
              if (updateQuoEntity?.payload["response"].data?.status === 500) {
                localStorage.setItem('showErrorDialog', 'true');
                localStorage.setItem('errorMessage', updateQuoEntity?.payload["response"].data?.title);
              }
            }
          });
          dispatch(createNotification(notificationEntity));

      } else if (!isLocalCommodity && !quoCreatedDate.isSame(today, 'day')) {
        const ttl = 'Error';
        const msg = translate("home.purchaseYesterday'sQuotation");
        localStorage.setItem('showErrorDialog', 'true');
        localStorage.setItem('errorTitle', ttl);
        localStorage.setItem('errorMessage', msg);
        // open dialog
        window.dispatchEvent(
          new CustomEvent('openErrorDialog', {
            detail: { title: ttl, message: msg, payload: res.payload['data'] },
          })
        );
        return;
      } else {
        setLoading(true);
        res.payload['data'];
      }
    });
  };

  useEffect(() => {
    const showError = localStorage.getItem('showErrorDialog');
    if (updateSuccess && clickPurchase && showError === 'false') {
      dispatch(
        getNotificationByUserId({
          userId: account?.id,
          fromDate: moment(from).format('yyyy/MM/DD'),
          toDate: moment(to).add(1, 'day').format('yyyy/MM/DD'),
        })
      );
      setTimeout(() => {
        props.history.push(`/home`);
      }, 3000);
    } else if (updateSuccess && clickPurchase && showError === 'true') {
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  }, [updateSuccess, clickPurchase]);

  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,
  // });

  const handleBack = () => {
    props.history.push(`/home`);
  };

  // const handlePrint = () => {
  //   const input = document.getElementById('divToPrint').innerHTML;
  //   const originalContents = document.body.innerHTML;
  //
  //   if (quotationEntity?.id) {
  //     document.body.innerHTML = input;
  //
  //     window.print();
  //
  //     document.body.innerHTML = originalContents;
  //
  //     window.location.reload();
  //   }
  // };

  const handlePrint = () => {
    const printContent = document.getElementById('divToPrint').innerHTML;
    // Get all loaded stylesheet URLs
    const styleSheets = Array.from(document.styleSheets)
      .map(styleSheet => {
        try {
          return styleSheet.href
            ? `<link rel="stylesheet" type="text/css" href="${styleSheet.href}" />`
            : `<style>${Array.from(styleSheet.cssRules)
                .map(rule => rule.cssText)
                .join('\n')}</style>`;
        } catch (e) {
          return '';
        }
      })
      .filter(Boolean)
      .join('\n');

    const locale = Storage.session.get('locale');
    const isArabic = locale === 'ar-ly';

    const newWindow = window.open('', '_blank');
    if (newWindow) {
      newWindow.document.write(`
            <html>
            <head>
                ${styleSheets}
                <style>
                    body {
                        ${isArabic ? "font-family: 'Amiri', serif; direction: rtl;" : ''}
                    }
                </style>
            </head>
            <body>
                <div id="printContainer">${printContent}</div>
            </body>
            </html>
        `);

      // Wait for stylesheets to load
      const loadPromises = Array.from(newWindow.document.getElementsByTagName('link')).map(
        link =>
          new Promise(resolve => {
            link.onload = resolve;
            link.onerror = resolve; // Continue even if some styles fail to load
          })
      );

      Promise.all(loadPromises).then(() => {
        setTimeout(() => {
          newWindow.print();
          newWindow.close();
        }, 500);
      });

      newWindow.document.close();
    }
  };

  useEffect(() => {
    if (
      Storage.session.get('locale') === 'ar-ly' &&
      itemDescription !== undefined &&
      itemDescription !== '' &&
      itemDescriptionInArabic === ''
    ) {
      const data = {
        q: itemDescription,
        source: 'en',
        target: 'ar',
        api_key: '',
      };
      axios.post(`https://translate.argosopentech.com/translate`, data).then(response => {
        setItemDescriptionInArabic(response?.data?.translatedText);
      });
    }
  }, [itemDescription]);

  useEffect(() => {
    if (account?.login !== undefined && !isReady) {
      if (quotationEntity?.branch?.id !== undefined) {
        setIsReady(true);
        dispatch(getBranch(quotationEntity?.branch?.id));
      }
    }
  }, [account, quotationEntity]);

  const handleToClose = () => {
    setOpenEmailDialog(false);
  };

  const handleEmailSend = () => {
    // const emailObject = {
    //   quotation_id: quotationEntity?.id,
    //   issued_date: date,
    //   item_name: quotationEntity?.commodity?.name,
    //   description: quotationEntity?.commodity?.description,
    //   amount: quotationEntity?.amount,
    //   price: quotationEntity?.commodityUnitPrice,
    //   quantity: quotationEntity?.commodityQuantity,
    //   customer_name: quotationEntity?.customer?.name,
    //   phone_no: quotationEntity?.customer?.tel,
    //   to_email: quotationEntity?.customer?.email,
    //   national_id: quotationEntity?.customer?.ic,
    // };
    // const userID = EMAILJS_USER_ID;
    // emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, emailObject, userID)
    //   .then(
    //     () => toast.success("Send successfully!"),
    //     () => toast.error("Send failed!")
    //   ).catch(err => toast.error(err));

    dispatch(sendEmailQuotationDetail(quotationEntity));
    setOpenEmailDialog(true);
  };

  const quotationType = useAppSelector(state => state.quotationType.selectedQuotationOption);
  const ibanEntity = useAppSelector(state => state.iban.entity);
  const qId = props.match.params.id;
  useEffect(() => {
    if (isLocalCommodity) {
      dispatch(getEntityByQuotationId(qId));
    }
  }, [isLocalCommodity, qId]);

  const [ibanValue, setIbanValue] = useState('');
  const [openIBANModal, setOpenIBANModal] = useState(false);
  const [selectedIBANOption, setSelectedIBANOption] = useState('later');
  const [ibanButtonActionType, setIbanButtonActionType] = useState<string | null>(null);
  const [isSubmittingIban, setIsSubmittingIban] = useState(false);

  const handleIBANInputChange = event => {
    setIbanValue(event.target.value || '');
  };
  const handleIBANRadioChange = event => {
    setSelectedIBANOption(event.target.value);
  };

  const isValidIBANNumber = () => {
    return ibanValue.length > 0 && ibanValue.length !== 30;
  };
  const getIBANHelperText = () => {
    return ibanValue.length > 0 && ibanValue.length !== 30 ? 'IBAN number should be exactly 30 digits long.' : '';
  };

  const handleIBANModal = buttonType => {
    setOpenIBANModal(!openIBANModal);
    setIbanButtonActionType(buttonType);
    setIsSubmittingIban(false);
    if (buttonType === 'EDIT') {
      setIbanValue(ibanEntity?.ibanNumber);
      setSelectedIBANOption('ibanNumber');
    } else if (buttonType === 'CLOSE') {
      setIbanValue('');
      setSelectedIBANOption('later');
    }
  };

  const handleIBANOption = async () => {
    if (selectedIBANOption === 'ibanNumber' && ibanValue !== null) {
      // Prevent double submission
      if (isSubmittingIban) {
        return;
      }

      setIsSubmittingIban(true);

      try {
        // Always fetch the latest state
        const res = await dispatch(getEntityByQuotationId(quotationEntity?.id));
        const latestIban = res.payload['data'];

        if (latestIban?.id && ibanButtonActionType !== 'EDIT') {
          // IBAN already exists
          alert(translate('comexApp.quotation.ibanExists'));
          setIsSubmittingIban(false);
          return;
        }

        // TO SAVE IBAN
        const ibanToSave: IIban = {
          ibanNumber: ibanValue,
          customerId: quotationEntity?.customer?.id,
          quotationId: quotationEntity?.id,
          ibanBankName: quotationEntity?.bank?.name || '',
          ibanBranchName: quotationEntity?.branch?.name || '',
        };

        if (ibanEntity?.id) {
          await dispatch(updateIban(ibanToSave));
        } else {
          await dispatch(createEntity(ibanToSave));
        }

        // Refresh IBAN data after save
        await dispatch(getEntityByQuotationId(quotationEntity?.id));
      } catch (error) {
        console.error('Error saving IBAN:', error);
      } finally {
        setIsSubmittingIban(false);
      }
    }
  };

  const handleIBANConfirm = async () => {
    if (selectedIBANOption === 'ibanNumber' && !ibanValue.trim()) {
      return;
    }

    // Prevent double click
    if (isSubmittingIban) {
      return;
    }

    setOpenIBANModal(false);
    await handleIBANOption();
  };

  const CustomerIBANSection = () => (
    <>
      {quotationEntity?.commodity?.ownership === 'Local' && (
        <Row className="justify-content-center" style={{ marginTop: '14px' }}>
          <Col md="8" lg="6" className="round-border mt-1" style={{ padding: '28px 42px' }}>
            <ThemeProvider theme={responsiveFont}>
              <Typography variant="body2" component="div">
                <strong>{translate('comexApp.quotation.customerInformation')}</strong>
              </Typography>
            </ThemeProvider>

            <Grid style={{ marginTop: '20px' }} className="row">
              <Grid item xs={12} sm={6} md={4} sx={{ fontSize: '14px' }}>
                <p>
                  <Translate contentKey="comexApp.quotation.ibanNumber">IBAN NUMBER</Translate>
                </p>
              </Grid>

              <Grid item xs={12} sm={6} md={8}>
                <div>
                  <IbanDisplayButton ibanEntity={ibanEntity} quotationEntity={quotationEntity} handleIBANModal={handleIBANModal} />
                </div>
              </Grid>
            </Grid>
          </Col>
        </Row>
      )}
    </>
  );

  useEffect(() => {
    if (specBranch?.id !== undefined && accountsUser && !isDone) {
      setIsDone(true);
    }
  }, [specBranch, accountsUser, isDone]);

  let responsiveFont = createTheme();
  responsiveFont = responsiveFontSizes(responsiveFont);

  const sameDayWithCreatedDay = date === moment().format('yyyy/MM/DD');

  const handleOnClickState = () => {
    setClickPurchase(!clickPurchase);
    setLoading(false);
  };

  const getCurrencyName = () => {
    return quotationEntity?.currencyIndex?.name || '';
  };

  const TransactionFeeField = ({ label, currencyNameLabel, feeValue }) => (
    <div
      className="form-group row"
      style={{ alignItems: 'center' }}
      hidden={quotationEntity?.bank?.displayFeeInTransactionCurrency === false}
    >
      <div className="col-sm-3">
        <Label>{translate(label)}</Label>
      </div>
      <div
        className="row col-sm-9"
        style={
          Storage.session.get('locale') === 'en'
            ? { paddingRight: '0px', paddingLeft: '24px' }
            : { paddingRight: '24px', paddingLeft: '0px' }
        }
      >
        <div className="col-5 col-sm-3 px-0 box-space">
          <ValidatedField
            id={`${currencyNameLabel}_currency_name`}
            name={currencyNameLabel}
            data-cy={currencyNameLabel}
            type="text"
            value={getCurrencyName()}
            disabled={true}
          />
        </div>
        <div className="col-7 col-sm-9 px-0 box-space">
          <ValidatedField
            id={`${currencyNameLabel}_fee`}
            name={`${currencyNameLabel}_fee`}
            data-cy={`${currencyNameLabel}_fee`}
            value={feeValue}
            disabled={true}
            style={{
              textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
            }}
          />
        </div>
      </div>
    </div>
  );

  const renderCustomerNameSection = () => (
    <div className="form-group row" style={{ alignItems: 'center' }}>
      <div className="col-sm-3">
        <Label>{translate('comexApp.quotation.customer')}</Label>
      </div>
      <div className="col-sm-9">
        <ValidatedField id="cust_name" name="cust_name" data-cy="cust_name" type="text" value={cusName || ''} disabled={true} />

        <ValidatedField id="cust_name_ar" name="cust_name_ar" data-cy="cust_name_ar" type="text" value={cusNameAr || ''} disabled={true} />
      </div>
    </div>
  );

  const getCustomerName = () => {
    if (quotationEntity?.commodity?.ownership === 'Local') {
      return quotationEntity?.customer?.nameArabic || '';
    }
    return quotationEntity?.customer?.name || '';
  };

  const customerNameDisplay = getCustomerName();

  const renderQuantityField = () => (
    <ValidatedField
      id="quantity_unit"
      name="quantity_unit"
      data-cy="quantity_unit"
      type="text"
      value={quotationEntity?.commodityUnit || 'Ton'}
      disabled={true}
    />
  );

  if (isDone) {
    if (
      account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER) ||
      (account?.authorities?.includes(AUTHORITIES.BANK_STAFF) && quotationEntity?.createdBy === account?.login) ||
      (account?.authorities?.includes(AUTHORITIES.AREA_MANAGER) && specBranch?.areaManagerId === account?.id) ||
      (account?.authorities?.includes(AUTHORITIES.BANK_MANAGER) && specBranch?.bank?.userId === account?.id) ||
      (account?.authorities?.includes(AUTHORITIES.CUSTOMER) && quotationEntity?.customer.ic.toLowerCase() === account?.login) ||
      (account?.authorities?.includes(AUTHORITIES.AUDITOR) && specBranch?.bank?.id?.toString() === account?.bankId) ||
      account?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
      account?.authorities?.includes(AUTHORITIES.ADMIN) ||
      account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER)
    ) {
      return (
        (!account?.authorities?.includes(AUTHORITIES.BANK_STAFF) || quotationEntity?.createdBy === account?.login) && (
          <>
            <div ref={componentRef}>
              <div className="overlay" hidden={loading}>
                <img
                  src="../../content/images/loading.gif"
                  style={{ alignContent: 'center', position: 'fixed', left: '46%', top: '40%', zIndex: '1000' }}
                  hidden={loading}
                />
              </div>

              <Row className="justify-content-center">
                <Col md="8" lg="6" style={{ marginTop: '26px' }}>
                  <ThemeProvider theme={responsiveFont}>
                    <Typography variant="h4" component="div">
                      {translate('comexApp.quotation.home.orderQuoted')}
                    </Typography>
                  </ThemeProvider>
                </Col>

                <Row className="justify-content-center" style={{ marginTop: '12px' }}>
                  <Col md="8" lg="6" className="round-border mt-1" style={{ padding: '28px 42px 28px 42px' }}>
                    <ThemeProvider theme={responsiveFont}>
                      <Typography variant="h6" component="div">
                        <strong>{translate('comexApp.quotation.orderInfoLabel')}</strong>
                      </Typography>
                    </ThemeProvider>
                    &nbsp;
                    <ValidatedForm defaultValues={quotationEntity} onSubmit={saveEntity}>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.quotationNo')}</Label>
                        </div>
                        <div className="col-sm-9 box-space">
                          <ValidatedField
                            id="quotation_number"
                            name="quotation_number"
                            data-cy="quotation_number"
                            type="number"
                            value={quotationEntity?.id || ''}
                            disabled
                            style={{
                              textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.date')}</Label>
                        </div>
                        <div className="col-sm-9 box-space">
                          <ValidatedField
                            id="date"
                            name="date"
                            data-cy="date"
                            value={dateAndTime ? moment(dateAndTime).local().format('YYYY/MM/DD HH:mm:ss') : ''}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.amount')}</Label>
                        </div>
                        <div
                          className="row col-sm-9"
                          style={
                            Storage.session.get('locale') === 'en'
                              ? {
                                  paddingRight: '0px',
                                  paddingLeft: '24px',
                                }
                              : { paddingRight: '24px', paddingLeft: '0px' }
                          }
                        >
                          <div className="col-5 col-sm-3 px-0 box-space">
                            <ValidatedField
                              id="currencyName"
                              name="currencyName"
                              data-cy="currencyName"
                              type="text"
                              disabled
                              value={getCurrencyName()}
                            />
                          </div>
                          <div className="col-7 col-sm-9 px-0 box-space">
                            <ValidatedField
                              id="amount"
                              name="amount"
                              data-cy="amount"
                              value={amountV?.toLocaleString() || ''}
                              disabled={true}
                              min={1}
                              style={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.itemName')}</Label>
                        </div>
                        <div className="col-sm-9 box-space">
                          <ValidatedField
                            id="item_name_option"
                            name="item_name"
                            data-cy="item_name"
                            type="text"
                            value={itemName || ''}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.description')}</Label>
                        </div>
                        <div className="col-sm-9 box-space">
                          <ValidatedField
                            id="description"
                            name="description"
                            data-cy="description"
                            type="textarea"
                            value={Storage.session.get('locale') === 'en' ? itemDescription : itemDescriptionInArabic || itemDescription}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.price')}</Label>
                        </div>
                        <div
                          className="row col-sm-9"
                          style={
                            Storage.session.get('locale') === 'en'
                              ? {
                                  paddingRight: '0px',
                                  paddingLeft: '24px',
                                }
                              : { paddingRight: '24px', paddingLeft: '0px' }
                          }
                        >
                          <div className="col-5 col-sm-3 px-0 box-space">
                            <ValidatedField
                              id="currencyName"
                              name="currencyName"
                              data-cy="currencyName"
                              type="text"
                              disabled
                              value={getCurrencyName()}
                            />
                          </div>
                          <div className="col-7 col-sm-9 px-0 box-space">
                            <ValidatedField
                              id="price"
                              name="price"
                              data-cy="price"
                              value={quotationEntity?.commodityUnitPrice?.toLocaleString() || ''}
                              disabled
                              style={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.quantity')}</Label>
                        </div>
                        <div
                          className="row col-sm-9"
                          style={
                            Storage.session.get('locale') === 'en'
                              ? { paddingRight: '0px', paddingLeft: '24px' }
                              : { paddingRight: '24px', paddingLeft: '0px' }
                          }
                        >
                          <div className="col-5 col-sm-3 px-0 box-space">{renderQuantityField()}</div>

                          <div className="col-7 col-sm-9 px-0 box-space">
                            <ValidatedField
                              id="quantity"
                              name="quantity"
                              data-cy="quantity"
                              // value={itemQuantity?.toLocaleString() || ''}
                              value={quotationEntity?.commodityQuantity?.toLocaleString() || ''}
                              disabled
                              style={{
                                textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="form-group row"
                        style={{ alignItems: 'center' }}
                        hidden={quotationEntity?.bank?.displayTransactionFee === false}
                      >
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.transactionFee')}</Label>
                        </div>
                        <div
                          className="row col-sm-9"
                          style={
                            Storage.session.get('locale') === 'en'
                              ? {
                                  paddingRight: '0px',
                                  paddingLeft: '24px',
                                }
                              : { paddingRight: '24px', paddingLeft: '0px' }
                          }
                        >
                          <div className="col-5 col-sm-3 px-0 box-space">
                            <ValidatedField
                              id="currencyName"
                              name="currencyName"
                              data-cy="currencyName"
                              type="text"
                              disabled
                              value={quotationEntity?.feeCurrencyIndex || ''}
                            />
                          </div>
                          <div className="col-7 col-sm-9 px-0 box-space">
                            <ValidatedField
                              id="fee"
                              name="fee"
                              data-cy="fee"
                              type="text"
                              value={
                                displayTransactionFee !== null
                                  ? displayTransactionFee.toLocaleString()
                                  : quotationEntity && (quotationEntity.transactionFee !== null && quotationEntity.transactionFee !== undefined)
                                    ? quotationEntity?.transactionFee?.toLocaleString() || ''
                                    : ((quotationEntity?.fee ?? 0) + (quotationEntity?.commission ?? 0)).toLocaleString() || ''
                              }
                              disabled
                              style={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}
                            />
                          </div>
                        </div>
                      </div>
                      {isDefaultCurrency && quotationEntity?.bank?.displayFeeInTransactionCurrency && (
                        <TransactionFeeField
                          label="comexApp.quotation.transactionFeeInQuotationCurrency"
                          currencyNameLabel="quotation_currency_name_option"
                          feeValue={(displayFeeInQuotationCurrency ?? quotationEntity?.feeInQuotationCurrency)?.toLocaleString() || ''}
                        />
                      )}
                      <div className="form-group row" style={{ alignItems: 'center' }} hidden>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.totalAmount')}</Label>
                        </div>
                        <div
                          className="row col-sm-9"
                          style={
                            Storage.session.get('locale') === 'en'
                              ? {
                                  paddingRight: '0px',
                                  paddingLeft: '24px',
                                }
                              : { paddingRight: '24px', paddingLeft: '0px' }
                          }
                        >
                          <div className="col-5 col-sm-3 px-0 box-space">
                            <ValidatedField
                              id="currencyName"
                              name="currencyName"
                              data-cy="currencyName"
                              type="text"
                              disabled
                              value={quotationEntity?.currencyIndex?.name || ''}
                            />
                          </div>
                          <div className="col-7 col-sm-9 px-0 box-space">
                            <ValidatedField
                              id="totalAmount"
                              name="totalAmount"
                              data-cy="totalAmount"
                              value={quotationEntity?.totalAmount?.toLocaleString() || ''}
                              disabled
                              style={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}
                            />
                          </div>
                        </div>
                      </div>
                      &nbsp;
                      <Divider />
                      &nbsp;
                      <ThemeProvider theme={responsiveFont}>
                        <Typography variant="h6" component="div">
                          <strong>{translate('comexApp.quotation.requestedBy')}</strong>
                        </Typography>
                      </ThemeProvider>
                      &nbsp;
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.nationalId')}</Label>
                        </div>
                        <div className="col-sm-9">
                          <ValidatedField
                            id="national_id"
                            name="national_id"
                            data-cy="national_id"
                            type="text"
                            value={cusIc || ''}
                            disabled={true}
                          />
                        </div>
                      </div>
                      {renderCustomerNameSection()}
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.nationality')}</Label>
                        </div>
                        <div className="col-sm-9">
                          <ValidatedField
                            id="nationality"
                            name="nationality"
                            data-cy="nationality"
                            type="text"
                            disabled
                            value={
                              Storage.session.get('locale') === 'en' ? quotationEntity?.customer?.nationality : selectedNationality?.Desc_ar
                            }
                          />
                        </div>
                      </div>
                      <div className="form-group row mb-2" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.phoneNo')}</Label>
                        </div>
                        <div className="col-sm-9">
                          <PhoneInput
                            country={'us'}
                            value={phone || ''}
                            inputStyle={{
                              marginBottom: '2%',
                              textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                              direction: 'ltr',
                            }}
                            disabled
                            disableDropdown={true}
                          />
                        </div>
                      </div>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.email')}</Label>
                        </div>
                        <div className="col-sm-9">
                          <ValidatedField id="email" name="email" data-cy="email" value={cusEmail || ''} disabled={true} />
                        </div>
                      </div>
                      {/* {renderIban()} */}
                      {operationTime === false && (
                        <div className="col-12 col-sm-12 btn-group-direction mb-2">
                          <span style={{ color: 'red' }}>{getMessage()}</span>
                        </div>
                      )}
                      {account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER) && !isLocalCommodity && !sameDayWithCreatedDay && (
                        <div className="col-12 col-sm-12 btn-group-direction mb-2">
                          <span style={{ color: 'red' }}>
                            <Translate contentKey="home.yesterday'sQuotation"></Translate>
                          </span>
                        </div>
                      )}
                      <PurchaseLabelMessage />
                      <div className="col-12 col-sm-12">
                        <div className="col-4 col-sm-4" style={{ display: 'inline-flex', justifyContent: 'flex-start' }}>
                          <Button
                            className={'btn-email'}
                            color="primary"
                            outline
                            id="save-entity"
                            data-cy="entityCreateSaveButton"
                            onClick={handleEmailSend}
                          >
                            <Translate contentKey="comexApp.quotation.emailBtnLabel">Email</Translate>
                          </Button>
                          <Dialog open={openEmailDialog} onClose={handleToClose}>
                            <DialogTitle></DialogTitle>
                            <DialogContent>
                              <DialogContentText style={{ color: 'black' }} className="mb-3">
                                <strong>{translate('comexApp.quotation.emailSent')}</strong> {translate('comexApp.quotation.emailSentDesc')}
                              </DialogContentText>
                            </DialogContent>
                            <DialogActions className="mx-3">
                              <DialogContentText>
                                <Button color="primary" onClick={handleToClose} autoFocus>
                                  {translate('comexApp.quotation.okButton')}
                                </Button>
                              </DialogContentText>
                            </DialogActions>
                          </Dialog>
                        </div>
                        <div className="col-8 col-sm-8 btn-group-direction">
                          <div style={{ display: 'inline-flex', justifyContent: 'flex-end' }}>
                            {quotationEntity?.bankManagerApproval === null &&
                              quotationEntity?.bankCustomerApproval === null &&
                              operationTime === true && (
                                <Button
                                  color="primary"
                                  id="save-entity"
                                  data-cy="entityCreateSaveButton"
                                  type="submit"
                                  disabled={isPurchaseLabelDisabled}
                                  onClick={handleOnClickState}
                                >
                                  <Translate contentKey="comexApp.quotation.purchaseLabel">Purchase</Translate>
                                </Button>
                              )}
                            {quotationEntity?.bankManagerApproval === null &&
                              quotationEntity?.bankCustomerApproval === null &&
                              operationTime === false && (
                                <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled>
                                  <Translate contentKey="comexApp.quotation.purchaseLabel">Purchase</Translate>
                                </Button>
                              )}

                            {(account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER) ||
                              account?.authorities?.includes(AUTHORITIES.PURCHASE_APPROVAL)) &&
                              quotationEntity?.bankManagerApproval === false && (
                                <Button
                                  className={'btn-approve-po'}
                                  color="primary"
                                  id="save-entity"
                                  data-cy="entityCreateSaveButton"
                                  type="submit"
                                  disabled={!operationTime || (!isLocalCommodity && !sameDayWithCreatedDay)}
                                  onClick={handleOnClickState}
                                >
                                  <Translate contentKey="comexApp.quotation.approvePurchaseBtnLabel">Approve Purchase</Translate>
                                </Button>
                              )}
                          </div>
                          <div
                            className="btn-group-link"
                            style={{ display: 'inline-flex', justifyContent: 'flex-end', alignItems: 'center' }}
                          >
                            {!account.authorities.includes(AUTHORITIES.CUSTOMER) && quotationEntity?.status === 'Quoted' && (
                              <Button
                                color="link"
                                className="px-1"
                                id="save-entity"
                                disabled={isPurchaseLabelDisabled}
                                data-cy="entityCreateSaveButton"
                                onClick={() => props.history.push(`/quotation/${quotationEntity?.id}/edit`)}
                              >
                                <Translate contentKey={isAmend ? 'comexApp.quotation.confirmBtnLabel' : 'comexApp.quotation.amendBtnLabel'}>
                                  Amend
                                </Translate>
                              </Button>
                            )}
                            &nbsp;
                            <Button color="link" className="px-1" id="save-entity" data-cy="entityCreateSaveButton" onClick={handlePrint}>
                              <Translate contentKey="comexApp.quotation.printBtnLabel">Print</Translate>
                            </Button>
                            &nbsp;
                          </div>
                        </div>
                      </div>
                    </ValidatedForm>
                  </Col>
                </Row>

              <TransactionRefNoSection/>
              <CustomerIBANSection/>
              {/* For ADD IBAN NUMBER */}
              <SlotProcessingDialog
                open={slotAlreadyProcessing !== null}
                slotType={slotAlreadyProcessing}
                onClose={() => setSlotAlreadyProcessing(null)}
              />

              <AddIbanDialog
                openIBANModal={openIBANModal}
                handleIBANModal={handleIBANModal}
                selectedIBANOption={selectedIBANOption}
                handleIBANRadioChange={handleIBANRadioChange}
                ibanValue={ibanValue}
                isValidIBANNumber={isValidIBANNumber}
                getIBANHelperText={getIBANHelperText}
                handleIBANInputChange={handleIBANInputChange}
                bankNameValue={quotationEntity?.bank?.name || ''}
                branchNameValue={quotationEntity?.branch?.name || ''}
                handleIBANConfirm={handleIBANConfirm}
                isSubmittingIban={isSubmittingIban}
              />
              <Col md="8" lg="6" style={{marginTop: '28px', marginBottom: '32px'}}>
                <Button onClick={handleBack}>
                  <FontAwesomeIcon icon="arrow-left"/>
                  &nbsp;
                  <Translate contentKey="entity.action.back">Back</Translate>
                </Button>
              </Col>
            </Row>
          </div>

          <div>
            {isBoubyanQuotation(quotationEntity)
              ? <BoubyanQuotationPrint
                  quotationEntity={quotationEntity}
                  bankStaffAccount={bankStaff}
                />
              : <QuotationPrint
                  quotationEntity={quotationEntity}
                  bankStaffAccount={bankStaff}
                />
            }
          </div>

            <ErrorDialog history={props.history} isLocalCommodity={isLocalCommodity} />
          </>
        )
      );
    } else {
      return (
        <h5 style={{ textAlign: 'center' }}>
          <Translate contentKey={'global.loading'} />
        </h5>
      );
    }
  } else {
    return (
      <>
        <h5 style={{ textAlign: 'center' }}>
          <Translate contentKey={'global.loading'} />
        </h5>
      </>
    );
  }
};

export default QuotationPurchase;
